import React, { Component } from 'react';
import "./InstagramLogin.css";
import $ from 'jquery';
import { ToastContainer } from 'react-toastify';
import toast from '../toast';
import { css } from 'glamor';
import Loader from 'react-loader';
import Form from 'react-validation/build/form';
import {
  FormGroup,
  Input,
  Modal, ModalBody
} from 'reactstrap';
import Button from 'react-validation/build/button';
class InstagramLogin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      username: '',
      password: '',
      startLoader: true,
      otpModal: false,
      instagramOtp: '',
      otpBodyResult: {}
    };
  }

  instagramUsername = (e) => {
    this.setState({ username: e.target.value });
  }

  notifySuccess = (msg) => {
    toast.success(msg);
  }

  notifyError = (msg) => {
    toast.error(msg);
  }

  instagramPassword = (e) => {
    this.setState({ password: e.target.value });
  }

  onChangeOtpText = (e) => {
    this.setState({ instagramOtp: e.target.value });
  }

  submitInstagramOtp = (event) => {
    event.preventDefault();
    console.log(this.state.instagramOtp.length)
    if (this.state.instagramOtp.length == 6) {
      this.setState({
        otpModal: !this.state.otpModal
      })
      this.submitOtpWithBody();
    }
  }

  submitOtpWithBody = () => {
    let self = this;
    let data = this.state.otpBodyResult;
    data.verifiedToken = this.state.instagramOtp;
    this.setState({
      startLoader: false
    })
    $.ajax({
      method: 'POST',
      url: '/api/v1/instagram/verification/otp',
      data: JSON.stringify(data),
      success: (success) => {
        this.setState({
          startLoader: true
        })
        window.close('', '_parent', '');
      },
      error: (err) => {
        this.setState({
          startLoader: true,
          otpModal: true
        })
        self.props.notifyError(err.responseJSON.message);
      }
    });
  }

  LoginWithInstagram = (event) => {
    event.preventDefault();
    this.setState({
      startLoader: false
    })
    let self = this;
    let data = {
      username: this.state.username,
      password: this.state.password
    }
    $.ajax({
      method: 'POST',
      url: '/api/v1/instagram/login',
      data: JSON.stringify(data),
      success: (success) => {
        this.setState({
          startLoader: true
        })
        if (success.response && success.response.two_factor_identifier) {
          self.props.notifySuccess(success.message);
          this.setState({
            otpModal: !this.state.otpModal,
            otpBodyResult: success.response
          })
        } else {
          window.close('', '_parent', '');
        }
      },
      error: (err) => {
        this.setState({
          startLoader: true
        })
        self.props.notifyError(err.responseJSON.error);
      }
    });
  }

  render() {
    return (
      <div className="instagram-background">
        <div className="instagram-login-page">
          <h1>LOGAR NO INSTAGRAM</h1>
          <div className="form">
            <form className="login-form">
              <Input type="text" placeholder="username" value={this.state.username} autoComplete="off" onChange={this.instagramUsername} />
              <Input type="password" placeholder="password" value={this.state.password} autoComplete="off" onChange={this.instagramPassword} />
              <button onClick={this.LoginWithInstagram}>login</button>
              <p className="message"> <a href="http://relaystream.com.br/privacy.html" target="_blank">Terms & Privacy</a></p>
            </form>
          </div>
        </div>
        <ToastContainer className={{ textAlign: 'center' }} progressClassName={css({ background: '#007aff' })} />
        <Loader loaded={this.state.startLoader}>
        </Loader>
        <Modal isOpen={this.state.otpModal} >
          <ModalBody className="otpInputModal">
            <Form className="DataFields" onSubmit={this.submitInstagramOtp}>
              <div className="row">
                <div className="col-sm-3 otpInput">
                  <label className="submitButton">Digite OTP</label>
                </div>
                <div className="col-sm-6">
                  <Input type="number" name="otp" value={this.state.instagramOtp} autoComplete="off" placeholder="Digite otp de 6 dígitos" onChange={this.onChangeOtpText} className="form-control" />
                </div>
              </div>
              <FormGroup className="text-center submitButton">
                <Button type="submit" className="btn btn--submit mx-auto">Enviar</Button>
              </FormGroup>
            </Form>
          </ModalBody>
        </Modal>
      </div>);
  }
}

export default InstagramLogin;



// WEBPACK FOOTER //
// ./src/components/InstagramLogin/InstagramLogin.js